<script>
    import { inventoryMethods, warehouseMethods } from '@state/helpers'
    import { mapGetters } from 'vuex'
    
    export default {
      name: 'TitleInventoryOnline',
      components: {},
      data() {
        return {
          emails: JSON.parse(window.localStorage.getItem('emails')) || [],
          message: '',
          subject: '',
          //* -- estados --
          downloading: false,
          sendingEmail: false,
          showEmailModal: false,
        }
      },
      computed: {
        ...mapGetters({
          own_warehouse_selected: 'retina/warehouse/own_warehouse_selected',
        }),
      },
      mounted() {
        this.subject = '(' + new Date(Date.now()).toLocaleDateString() + ') Inventario'
        this.message = 'Buen día,\n\nSe adjunta el inventario actual'
        this.message += '\n\nCualquier duda comuníquese con su asesor comercial.\n\nPor favor no responder a este correo.'
      },
      methods: {
        ...inventoryMethods,
        ...warehouseMethods,
        returnConsultWarehouse() {
          this.setOwnInventoryOnlineMode(false)
          this.setConsultWarehouse(true)
        },
        validator(tag) {
          let exr = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i
          let validEmail = exr.test(tag)
          // const required = (val) => val && val.length;
          return validEmail
        },
        getInventoryReport() {
          this.downloading = true
          let query_format =
            '?download=true' +
            '&warehouse=' +
            this.own_warehouse_selected.id +
            '&ubication='
    
          this.fetchInventoryReport(query_format)
            .then((response) => {
              this.downloading = false
              if(response.status == 204) {
                this.$generate_toast(this, 'info', 'La bodega no tiene productos en inventario')
              }
              else {
                const data = response.data
                const url = URL.createObjectURL(
                  new Blob([data], {
                    type: 'application/vnd.ms-excel',
                  })
                )
                const link = document.createElement('a')
                link.href = url
                link.setAttribute(
                  'download',
                  `Reporte Inventario ${this.own_warehouse_selected.description}.xlsx`
                )
                document.body.appendChild(link)
                link.click()
              }
            })
            .catch((error) => {
              this.downloading = false
              this.$axios_error_noty(error, this)
              // console.log('Se presento un error en la descarga del archivo.', error)
            })
        },
        send() {
          // !agregar validación de correos antes de enviar 
          let query_format =
            '?warehouse=' + this.own_warehouse_selected.id + '&ubication='
    
          let data = {
            To_emails: this.emails,
            subject: this.subject,
            message: this.message,
            warehouse: this.own_warehouse_selected.description,
          }
          window.localStorage.setItem('emails', JSON.stringify(this.emails))
    
          let r = {
            query: query_format,
            body: data,
          }
          this.showEmailModal = false
          this.sendingEmail = true
          this.sendEmail(r)
            .then((response) => {
              // console.log(response)
              this.sendingEmail = false
              if(response.status == 204) {
                this.$generate_toast(this, 'info', 'Correo no enviado, la bodega no tiene productos en inventario')
              }
              else {
                this.$generate_toast(this, 'success', response.data.status)
              }
            })
            .catch((error) => {
              // console.log(error)
              this.sendingEmail = false
              this.$generate_toast(this, 'error', 'No se pudo enviar correo')
            })
        },
      },
    }
    </script>
    <template>
      <b-card no-body class="p-2" v-if="own_warehouse_selected">
        <span class="text-primary font-weight-lighter">Lugar seleccionado:</span>
        <b-card-title>{{ own_warehouse_selected.description }}</b-card-title>
        <b-card-sub-title class="mb-2 lead">
          <b-badge variant="primary">{{ own_warehouse_selected.code }}</b-badge>
        </b-card-sub-title>
        <b-card-footer footer-bg-variant="transparent" footer-class="p-0">
          <b-button-group class="w-100">
            <b-button
              @click="returnConsultWarehouse()"
              variant="outline-danger"
              class="mr-1"
              style="max-width: 40px"
            >
              <i class="fas fa-times"></i>
            </b-button>
    
            <b-button
              :disabled="downloading||sendingEmail"
              @click="showEmailModal=!showEmailModal"
              variant="outline-secondary"
              class="mr-1"
            >
            <div v-if="!sendingEmail">
              <i class="fas fa-envelope"></i> Enviar Correo
            </div>
            <span
                v-if="sendingEmail"
                class="spinner-border spinner-border-sm text-primary"
                role="status"
              >
              </span>
              <span v-if="sendingEmail"> Enviando Correo ... </span>
            </b-button>
    
            <b-button
              :disabled="downloading||sendingEmail"
              @click="getInventoryReport()"
              variant="outline-success"
            >
              <div v-if="!downloading">
                <i class="fas fa-file-excel"></i> Descargar Excel
              </div>
              <span
                v-if="downloading"
                class="spinner-border spinner-border-sm text-success"
                role="status"
              >
              </span>
              <span v-if="downloading"> Descargando ... </span>
            </b-button>
          </b-button-group>
        </b-card-footer>
    
    
    
        <b-modal
            v-model="showEmailModal"
            hide-footer
            id="email"
            size="xl"
            title="Enviar Inventario por Correo"
          >
            <!-- <div class="d-flex w-100 justify-content-between col-xl-6"> -->
            <b-form-group
              class="mt-2"
              id="fieldset-horizontal"
              label-cols-sm="2"
              label-cols-lg="2"
              content-cols-sm
              content-cols-lg="7"
              label="Correos:"
              label-for="input-horizontal"
            >
              <b-form-tags
                placeholder="Agregar correo..."
                input-id="tags-state-event"
                tag-variant="light"
                tag-pills
                size="md"
                v-model="emails"
                :tag-validator="validator"
                add-button-text="Agregar"
                add-button-variant="primary"
                invalid-tag-text="Correo inválido"
                :separator="[',', ' ',';']"
              >
              <!-- @tag-state="onTagState" -->
              </b-form-tags>
            </b-form-group>
    
            <b-form-group
              class="mt-2"
              id="fieldset-horizontal"
              label-cols-sm="2"
              label-cols-lg="2"
              content-cols-sm
              content-cols-lg="7"
              label="Asunto:"
              label-for="input-horizontal"
            >
              <b-form-input v-model="subject" id="input-horizontal"></b-form-input>
            </b-form-group>
    
            <div>
              <b-form-textarea
                v-model="message"
                id="textarea-no-resize"
                placeholder="Mensaje"
                rows="10"
                no-resize
              ></b-form-textarea>
            </div>
    
            <b-button @click="send()" :disabled="emails.length === 0" class="mt-2" variant="success">
              <i class="fas fa-mail-bulk"></i> Enviar
            </b-button>
          </b-modal>
        </b-card>
    </template>
    